import { changeToImageSize, ImageSize } from '@ecg-marktplaats/media-util-js-lib';

const imageSizeFormatter = ({
  imageUrlFromApi,
  customSize = ImageSize.Medium,
}: {
  imageUrlFromApi: unknown;
  customSize?: ImageSize;
}) => changeToImageSize(imageUrlFromApi, customSize, { allowPlaceholder: true, allowedSizes: [ImageSize.Medium] });

export default imageSizeFormatter;
